import { createFileRoute } from "@tanstack/react-router";

import NotificationsPage from "@/admin/notifications/page";

export const Route = createFileRoute("/app/$storeId/notifications")({
    component: RouteComponent,
});

function RouteComponent() {
    return <NotificationsPage />;
}
